module.exports = __webpack_public_path__ + "img/videoclip.808007c3.jpg";